import emailValidator from 'email-validator';
import PasswordValidator from 'password-validator';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  termsValidationError: {
    id: 'formValidation.terms.error',
    defaultMessage: 'Terms of Use must be accepted.',
  },
  emailValidationError: {
    id: 'formValidation.email.error',
    defaultMessage: 'This field must be a valid email address',
  },
  passwordValidationError: {
    id: 'formValidation.password.error',
    defaultMessage:
      'Password must be 8-24 characters and include at least one: upper case letter, lowercase letter and number.',
  },
  nameValidationError: {
    id: 'formValidation.name.error',
    defaultMessage: "This field can't be blank",
  },
});

const passwordSchema = new PasswordValidator();
passwordSchema
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits()
  .isMin(8)
  .isMax(24);

export default class FormValidation {
  static validateAll(names, fields) {
    const errors = [];
    names.forEach(name => {
      const value = fields[name];
      const message = FormValidation.validate(name, value);
      if (message) {
        errors.push(message);
      }
    });
    return errors.length > 0 ? errors : null;
  }

  static validate(name, value) {
    switch (name) {
      case 'terms':
        return FormValidation.validateTerms(value);
      case 'email':
        return FormValidation.validateEmail(value);
      case 'password':
        return FormValidation.validatePassword(value);
      case 'firstName':
      case 'lastName':
        return FormValidation.validateName(value);
      default:
        return null;
    }
  }

  static validateTerms(terms) {
    const isValid = !!terms;
    if (!isValid) {
      return messages.termsValidationError;
    }
    return null;
  }

  static validateEmail(email) {
    if (!emailValidator.validate(email)) {
      return messages.emailValidationError;
    }
    return null;
  }

  static validatePassword(password) {
    try {
      if (!passwordSchema.validate(password)) {
        return messages.passwordValidationError;
      }
    } catch (err) {
      return messages.passwordValidationError;
    }
    return null;
  }

  static validateName(name) {
    if (typeof name !== 'string' || name.length <= 0 || name.length > 35) {
      return messages.nameValidationError;
    }
    return null;
  }
}
